// extracted by mini-css-extract-plugin
export default {"homeContainer":"home_homeContainer__BlufY","categoriesWrapper":"home_categoriesWrapper__5IrsH","category":"home_category__-xGEa","categoryImg":"home_categoryImg__2EnS3"};